export const languageToIso6391 = {
  English: "eng",
  Spanish: "spa",
  French: "fra",
  German: "deu",
  Chinese: "zho",
  Japanese: "jpn",
  Korean: "kor",
  Urdu: "urd",
  Arabic: "ara",
  // Add more languages and their ISO 639-1 codes here
};
export function convertToIso6391(languageName) {
  if (!languageName || typeof languageName !== "string") {
    throw new Error(
      "Language name cannot be null or empty and must be a string"
    );
  }

  const languages = languageName.split(",").map(lang => lang.trim());

  const isoCodes = languages.map(lang => {
    const formattedLang = lang.charAt(0).toUpperCase() + lang.slice(1).toLowerCase();
    const isoCode = languageToIso6391[formattedLang];

    if (!isoCode) {
      throw new Error(`ISO 639-1 code for language '${lang}' not found`);
    }
    return isoCode;
  });

  return isoCodes.join(", "); 
}

